import { z } from 'zod';
import { PROVEEDORES_AUTH, ROLES } from '../enums.js';
import { emailSchema, passwordSchema } from './auth.js';
export const usuarioCrearSchema = z.object({
    email: emailSchema,
    nombre: z.string().min(2).max(120),
    rol: z.enum(ROLES),
    // password inicial opcional; si no se provee, admin debe usar reset-password después.
    passwordInicial: passwordSchema.optional(),
});
export const usuarioActualizarSchema = z.object({
    nombre: z.string().min(2).max(120).optional(),
    rol: z.enum(ROLES).optional(),
    activo: z.boolean().optional(),
});
// Output al cliente — nunca incluye passwordHash ni info sensible.
export const usuarioPublicSchema = z.object({
    id: z.string(),
    email: z.string(),
    nombre: z.string(),
    rol: z.enum(ROLES),
    activo: z.boolean(),
    debeCambiarPassword: z.boolean(),
    proveedorAuth: z.enum(PROVEEDORES_AUTH),
    creadoEn: z.string(), // ISO
    actualizadoEn: z.string(),
});
// Respuesta de reset-password: el admin recibe la contraseña temporal una vez.
export const usuarioResetPasswordResponseSchema = z.object({
    passwordTemporal: z.string(),
});
//# sourceMappingURL=usuario.js.map